import { contractTemplateFormInitialStatus as initialStatus } from './contractTemplateFormInitialStatus';
import { contractTemplateFormInitialValue as initialValues } from './contractTemplateFormInitialValue';

export default { initialValues, initialStatus };
